module.exports = __webpack_public_path__ + "static/media/fly0137.39e5bdd1.webp";